"use strict";
// @ts-ignore
try {
    self['workbox:recipes:7.0.0'] && _();
}
catch (e) { }
